import { CompanyState } from './types'
import { ActionTree } from 'vuex'
import { RootState } from '../../types'

export const actions: ActionTree<CompanyState, RootState> = {
  set({ commit }, value: CompanyState): void {
    commit('set', value)
  }
}
